import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Chip,
  Paper,
  Box,
  Button,
  Backdrop,
  CircularProgress,
  useTheme,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import history from "../../utils/HistoryUtils";
import AlertDialog from "../../components/Alert/AlertDialog";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../../components/Notification/Notification";
import { changeShiftStatus, deleteBooking } from "../../store/action";
import CandidatesList from "./CandidatesList";
import { getSingleBooking } from "../../store/action/booking/bookingAction";
import Loading from "../../components/Loading/Loading";
import { ArrowBack } from "@material-ui/icons";

const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.main
  }
}));

const DetailBooking = ({ match }) => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const booking_id = match.params.id;
  const [Id, setId] = useState(false);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const [bookingDetail, setBookingDetail] = useState([]);
  const [initialData, setInitialData] = useState([])
  const [loading, setLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);
  const [bookingNotify, setBookingNotify] = useState(false);
  const [confirmBtn, setConfirmBtn] = useState(false);
  const loginUserInfo = JSON.parse(window.localStorage.getItem("loginUserInfo"));
  const [candidateAssignDetails, setCandidateAssignDetails] = useState({})

  const { deleteBookingSuccess, deleteBookingError, shiftStatusSuccess } =
    useSelector((state) => state.booking);
  // const { deleteBookingSuccess, deleteBookingError, confirmBookingSuccess, confirmBookingError, invitationSuccess, shiftStatusSuccess } = useSelector(state => state.booking)

  const [bookingStatus, setBookingStatus] = useState({
    booking_id: "",
    status: "",
  });

  const upadateLink = () => {
    history.push(`update`);
  };

  const getBookingDetail = async () => {
    setLoading(true);
    try {
      dispatch(
        getSingleBooking({ booking_id, }, (result) => {
          setBookingDetail(result);
          setInitialData(result)
          setLoading(false);
        }
        )
      );
    } catch (error) {
      console.error("error.message", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getBookingDetail();
  }, []);

  const deleteBookingClose = () => {
    setDeleteOpen(false);
  };

  const deleteStaffItem = (id) => {
    setDeleteOpen(true);
    setId(id);
  };

  const alertResponse = (id) => {
    dispatch(deleteBooking(id));
    setStaffNotify(true);
  };

  const backPage = () => {
    history.push("/admin/reports");
  };

  const handleBookingStatus = (event, id) => {
    setBookingStatus({
      ...bookingStatus,
      [event.target.name]: event.target.value,
      booking_id: id,
    });
  };

  useEffect(() => {
    if (bookingStatus.booking_id !== "") {
      dispatch(changeShiftStatus(bookingStatus));
      setBookingNotify(true);
      setTimeout(() => {
        getBookingDetail();
      }, 4000);
    }
  }, [bookingStatus]);
  return (
    <>
      {loading && <Loading open={loading} />}

      {staffNotify && deleteBookingSuccess?.message && (
        <Notification data={deleteBookingSuccess?.message} status="success" />
      )}
      {staffNotify && deleteBookingError?.message && (
        <Notification data={deleteBookingError?.message} status="error" />
      )}

      {bookingNotify && shiftStatusSuccess?.message && (
        <Notification data={shiftStatusSuccess?.message} status="success" />
      )}

      <Paper elevation={3} className={`${classes.root} mb-6`}>
        <Box p={2} >
          <Box container display="flex" justifyContent="flex-end" alignItems="center">
            {/* <Typography variant="h6" fontWeight="600" color="primary">Booking Details</Typography> */}
            <Button color="primary" variant="outlined" onClick={backPage} startIcon={<ArrowBack />}>
              Back
            </Button>
          </Box>
          <Grid container spacing={3} p={3}>
            {/* Booking info fields */}
            {[
              { label: "Reference ID", value: bookingDetail?.data?.reference_id },
              { label: "Customer Name", value: bookingDetail?.data?.name },
              { label: "Site Name", value: bookingDetail?.data?.hospital_name },
              { label: "Ward Name", value: bookingDetail?.data?.ward_name },
              { label: "Band Required", value: bookingDetail?.data?.grade_name },
              {
                label: "Date",
                value: bookingDetail?.data?.date
                  ? bookingDetail?.data?.date.toString().split("-").reverse().join("-")
                  : "",
              },
              {
                label: "Shift Time",
                value: `${bookingDetail?.data?.start_time} - ${bookingDetail?.data?.end_time}`,
              },
              { label: "Shift Type", value: bookingDetail?.data?.shift_type },
              { label: "Payable", value: `£ ${bookingDetail?.data?.payable}` },
            ].map((item, idx) => (
              <Grid item xs={12} sm={6} lg={3} key={idx}>
                <Typography variant="body2" style={{ color: theme.palette.listItem }}>{item.label}</Typography>
                <Typography variant="subtitle1" fontWeight="600">{item.value || "-"}</Typography>
              </Grid>
            ))}

            {/* Speciality section */}
            <Grid item xs={12} md={6}>
              <Typography variant="body2" style={{ color: theme.palette.listItem }} >Speciality</Typography>
              <Box display="flex" flexWrap="wrap" gap={1}>
                {bookingDetail?.data?.speciality?.length ? (
                  bookingDetail?.data?.speciality.map((list, index) => (
                    <Chip
                      key={index}
                      label={list.speciality_name}
                      color="primary"
                      variant="outlined"
                    />
                  ))
                ) : (
                  <Typography variant="subtitle2" color="textDisabled">
                    No speciality assigned
                  </Typography>
                )}
              </Box>
            </Grid>

            {/* Action buttons */}
            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" gap={2}>
                {bookingDetail?.data?.status === "CREATED" && (
                  <Button variant="contained" color="primary" onClick={upadateLink} startIcon={<EditIcon />}>
                    Edit
                  </Button>
                )}

                {(staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION") &&
                  bookingDetail?.data?.status === "CREATED" && (
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => deleteStaffItem(bookingDetail?.data?.id)}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </Button>
                  )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>


      {bookingDetail?.data?.status !== "CANCEL" && (
        <CandidatesList
          bookingDetail={bookingDetail}
          booking_id={booking_id}
          getBookingDetail={getBookingDetail}
          setConfirmBtn={setConfirmBtn}
          setBookingDetail={setBookingDetail}
          initialData={initialData}
          setCandidateAssignDetails={setCandidateAssignDetails}

        />
      )}

      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deleteBookingClose}
        response={alertResponse}
        title="Delete Booking"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />
    </>
  );
};

export default DetailBooking;
